/**
 * Colour-scheme preference values persisted for the user.
 * Doubles as the stored value inside the theme store's persist envelope —
 * see `THEME_STORAGE_KEY`.
 */
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
} as const;

/** One of the supported colour schemes. */
export type Theme = (typeof THEMES)[keyof typeof THEMES];

/**
 * localStorage key holding the preference. Prefixed with `brightlocal_`
 * (`prefixKey`), so the full key is `brightlocal_theme`. The value is the
 * Zustand persist envelope (`{"state":{"theme":…},"version":0}`) written by
 * `useThemeStore` — kept in sync with the pre-paint script in `index.html`,
 * which reads `state.theme` directly.
 */
export const THEME_STORAGE_KEY = 'theme';

/**
 * Class the design system's token layer keys dark mode off
 * (`@variant dark (&:is(.dark *))` in `@brightlocal/tokens`). Separate from
 * `THEMES.DARK` on purpose: one is our stored value, this is the DS contract.
 */
export const DARK_CLASS_NAME = 'dark';
